<template>
  <div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else>
      <div v-if="mode !== 'edit'">
        <div>
          <form-accordion :title="$t('common.security.certificat')" :isTitleUpperCase="false">
            <b-row class="d-flex align-items-center form-group">
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputValue="currentCertificate[0].name"
                  :inputLabel="$t('common.security.name')"
                  :placeholderValue="$t('common.security.name')"
                />
              </b-col>
            </b-row>
            <b-row class="d-flex align-items-center form-group">
              <b-col sm="6" class="form-group mb-5">
                <form-read-group-label-input
                  :inputValue="getDate(currentCertificate[0].startDate)"
                  :inputLabel="$t('common.security.startDate')"
                  :placeholderValue="$t('common.security.startDate')"
                />
              </b-col>
              <b-col sm="6" class="form-group mb-5">
                <form-read-group-label-input
                  :inputValue="getDate(currentCertificate[0].endDate)"
                  :inputLabel="$t('common.security.endDate')"
                  :placeholderValue="$t('common.security.endDate')"
                />
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputValue="currentCertificate[0].deliveredBy"
                  :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputValue="currentCertificate[0].deliveredTo"
                  :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto mb-4" />
          <form-accordion :title="$t('common.security.private_key')" :isTitleUpperCase="false">
            <b-row class="d-flex justify-content-center align-items-center form-group">
              <b-col sm="6" class="form-group mb-5">
                <!-- <form-read-group-label-input :input-value="currentCertificate[0].password"
                  :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
                </form-read-group-label-input> -->
                <div>
                  <label>{{$t('common.security.password')}}</label>
                  <div class="d-flex">
                    <input
                      :value="getPassword()"
                      class="form-control inputAccordionForm inputLogin h-30px"
                      :type="passwordFieldType"
                      readonly
                      autocomplete="off">
                    </input>
                    <i class="icon icon-password mt-2 pt-1"
                      :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                      @click="toggleVisibility">
                    </i>
                  </div>
                </div>
              </b-col>
              <b-col sm="6" class="form-group mb-5"></b-col>
            </b-row>
          </form-accordion>
        </div>

      </div>
      <div v-else>
        <certificate-form-edit class="mt-3" ref="keystoreFormPem" :store="1" :keystore="keystoreForEdit" :technical-user="technicalUser" :id-company="idCompany" :name-company="nameCompany" :id-user-api="idUserApi" :id-rights-profile-api="idRightsProfileApi" :id-certificate="idCertificate" :id-private-key="idPrivateKey"></certificate-form-edit>
      </div>
    </div>
  </div>
</template>
<script>

import Spinner from '@/components/common/spinner.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import CertificateFormEdit from "@/pages/administration/CertificateFormEdit.vue";
import moment from 'moment-timezone';

export default {
  name: 'KeystoreFormGlobal',
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'spinner': Spinner,
    'certificate-form-edit': CertificateFormEdit
  },
  props: {
    mode: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: '-1'
    },
    technicalUser: {
      type: Boolean,
      default: false
    },
    idCertificate: {
      type: String,
      default: ''
    },
    idPrivateKey: {
      type: String,
      default: ''
    },
    idCompany: {
      type: String,
      default: ''
    },
    idUserApi: {
      type: String,
      default: ''
    },
    idRightsProfileApi: {
      type: String,
      default: ''
    },
    nameCompany: {
      type: String
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    listCertificateOutGroup () {
      return this.listCertificates.filter(elem => {
        return !elem.inGroup
      })
    },
    listCertificateInGroup () {
      return this.listCertificates.filter(elem => {
        return elem.inGroup
      })
    },
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    keystoreForEdit () {
      const certificate = this.currentCertificate[0] || {}
      const privateKey = this.currentPrivateKey[0] || {}

      return {
        ...certificate,

        // Identifiants nécessaires à CertificateFormEdit
        privateKey: privateKey.privateKey,

        // Mot de passe de la clé privée
        password: privateKey.password === '$NotFound'
        ? ''
        : (privateKey.password || '')
      }
    }
  },
  data: () => {
    return {
      activateSpinner: false,
      currentCertificate: [],
      currentPrivateKey: [],
      fields: [],
      formType: '',
      name: '',
      pageTitle: '',
      listCertificates: [],
      refreshTab: false,
      passwordFieldType: 'password'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    this.formType = this.mode

    Promise.all([
      this.getCertificate(),
      this.getPrivatekey()
    ]).then(() => {
      if (this.currentCertificate.length && this.currentPrivateKey.length) {
        this.currentCertificate[0].password =
          this.currentPrivateKey[0].password
      }
    })

    this.fields.push({ key: 'name', tdClass: 'text-center' })
  },
  methods: {
    saveKeystore() {
      // Appeler la méthode updateKeystore du composant KeystoreFormPEM
      if (this.$refs.keystoreFormPem) {
        this.$refs.keystoreFormPem.updateKeystore()
      }
    },
    deleteKeystore() {
      let that = this

      this.$f7.modal({
        title: this.$t('common.security.keystore_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: that.id
              }
              that.$engine.firstOn().security.keystore.delete(params)
              .then(() => {
                that.$f7.modal({
                  title: that.$t('common.security.keystore_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
                loadPage(that, {url: '/security/1'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.ca_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    formHasError () {
      if (this.name.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_name_missing'))
        return true
      }
      if (this.listCertificateInGroup.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_cert_missing'))
        return true
      }
      return false
    },
    getCertificate () {
      return this.$engine.security.certificates.fetch({
        id: this.idCertificate,
        idCompany: this.idCompany
      }).then(resp => {
        this.currentCertificate = resp.data.certificates || []
      }).catch(error => {
        errorMessageAlert(error, this)
      })
    },

    getPrivatekey () {
      return this.$engine.security.private_keys.fetch({
        id: this.idPrivateKey,
        idCompany: this.idCompany
      }).then(resp => {
        this.currentPrivateKey = resp.data.privateKeys || []
      }).catch(error => {
        errorMessageAlert(error, this)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRowSelectedInGroup (certificates) {
      for (let i = 0; i < this.listCertificateInGroup.length; i++) {
        this.listCertificateInGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    onRowSelectedOutGroup (certificates) {
      for (let i = 0; i < this.listCertificateOutGroup.length; i++) {
        this.listCertificateOutGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    selectCertificate(certificate){
      if(!this.isEditable){
        return
      }
      certificate.selected = !certificate.selected ? true : false
      this.refreshTab = !this.refreshTab
    },
    switchMode (mode) {
      this.formType = mode
    },
    getDate (date) {
      if (!date) return '-';

      const d = new Date(String(date).replace(" ", "T"))
      if (isNaN(d)) return ""
      const pad = n => String(n).padStart(2, "0")
      return (
        `${d.getFullYear()}-` +
        `${pad(d.getMonth() + 1)}-` +
        `${pad(d.getDate())} ` +
        `${pad(d.getHours())}:` +
        `${pad(d.getMinutes())}:` +
        `${pad(d.getSeconds())}`
      )
    },
    toggleVisibility () {
      this.passwordFieldType =
        this.passwordFieldType === 'password'
          ? 'text'
          : 'password'
    },
    getPassword () {
      const password =
        this.currentPrivateKey.length &&
        this.currentPrivateKey[0].password
          ? this.currentPrivateKey[0].password
          : ''

      return password === '$NotFound' ? '' : password
    }
  }
}

</script>
<style scoped>
.btn.btn-secondary {
  background: var(--actionButtonColorViolet);
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
}

.sdd-select {
  display: block;
  width: 90px;
}

.justify-content-around label {
  display: block;
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 2px;
}

.justify-content-around label.sdd-label-main,
.d-flex label.sdd-label-main {
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 1rem !important;
}
.sdd-select-header label {
  display: block;
  text-align: center;
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 2px;
}
.justify-content-around label:not(.sdd-label-main) {
  font-size: 1rem !important;
  color: #212529 !important;
}
.sdd-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-file-generation-settings {
  padding: 5px 0 10px 300px;
}
.expiring-mandates-settings {
  padding: 5px 0 10px 280px;
}
.generation-row {
  margin-bottom: 2px;
}

.custom-control {
  min-height: 18px;
  padding-left: 25px;
}

.custom-control-label::before,
.custom-control-label::after {
  width: 12px;
  height: 12px;
  top: 3px;
}

.interval-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 25px;
}

.interval-selects {
  display: flex;
  gap: 5px;
  margin-left: 100px;
  margin-top: -2px;
}

.interval-selects select {
  width: 130px;
}
.interval-selects-type {
  display: flex;
  gap: 5px;
  margin-left: 225px;
  margin-top: -2px;
}

.interval-selects-type select {
  width: 160px;
}


.sct-file-row {
  display: flex;
  align-items: flex-start;
}

.sct-file-options {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-top: -4px;
}

.sct-file-options .custom-checkbox {
  margin-bottom: 4px;
}
.space {
  margin-left: 10px;
}
</style>
